import { render, staticRenderFns } from "./ImgShadow.vue?vue&type=template&id=5619e27e&"
import script from "./ImgShadow.vue?vue&type=script&lang=js&"
export * from "./ImgShadow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-img-shadow.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports